import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import type Mithril from 'mithril';
import { slug } from '../../common';

export default function extendLoginSignupModal() {
	const assetsBaseUrl = `/assets/extensions/${slug}`;

	extend(LogInModal.prototype, 'fields', function (items) {
		items.add('cooperation-byline', content(), -20);
	});

	extend(SignUpModal.prototype, 'fields', function (items) {
		items.add('cooperation-byline', content(), -20);
	});

	function content(): Mithril.Vnode {
		return (
			<div className="Form-group Modal-byline">
				<p>{app.translator.trans('glowingblue-thalia.forum.cooperation_byline')}</p>
				<img src={`${assetsBaseUrl}/brandlogo--thalia.svg`} fetchpriority="low" alt="thalia" />
				<p>|</p>
				<img src={`${assetsBaseUrl}/brandlogo--osiander.svg`} fetchpriority="low" alt="osiander" />
			</div>
		);
	}
}
